//
//
//
//
//
//
//
//
//
//
//
import { DateMixin } from '@/mixins/DateMixin';
export default {
  name: 'yearSelect',
  mixins: [DateMixin],
  mounted: function mounted() {
    this.$emit("change", this.yearTime);
  },
  methods: {
    // 年变化
    handleYearChange: function handleYearChange(value) {
      this.yearTime = value;
      this.$emit('change', this.yearTime);
    }
  }
};